<template>
  <!-- display: contents : garde la nav sticky par rapport à la page (Vue 2 = une seule racine) -->
  <div class="blognav-root">
  <!-- Bandeau acquisition Lexroom (style aligné sur pravenintelekt.com) : ouvre la pop-up de demande de démo -->
  <a
    class="lexroom-banner"
    :href="CALENDLY_DEMO_URL"
    @click.prevent="openCalendlyDemo"
    target="_blank"
    rel="noopener"
  >
    <span class="lexroom-banner-inner">
      <span>{{ t('landing.blogNav.lexroomBanner') }}</span>
      <strong class="lexroom-banner-brand">Lexroom</strong>
      <svg class="lexroom-banner-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
    </span>
  </a>

  <nav class="my-nav">
    <!-- Brand (logo → landing) -->
    <a href="/" class="my-nav-brand" :aria-label="t('landing.blogNav.brandAriaLabel')">
      <img :src="logoQueryLexroom" :alt="t('landing.blogNav.logoAlt')" class="my-nav-logo" width="67" height="40" />
    </a>

    <!-- Center links -->
    <ul class="my-nav-links">
      <li><a class="my-nav-link" href="/">{{ t('landing.blogNav.product') }}</a></li>
      <li><a class="my-nav-link" href="https://www.query-juriste.com/blog">{{ t('landing.blogNav.blog') }}</a></li>
      <li><a class="my-nav-link" href="https://www.query-juriste.com/actualite">{{ t('landing.blogNav.news') }}</a></li>
      <li><a class="my-nav-link" href="/pressPage">{{ t('landing.blogNav.press') }}</a></li>
    </ul>

    <!-- Right actions -->
    <div class="my-nav-actions">
      <a href="/loginPage" class="signin-link">{{ t('landing.blogNav.signin') }}</a>
      <a
        class="cta-btn"
        href="https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique"
        @click.prevent="openCalendlyDemo"
      >{{ t('landing.blogNav.bookDemo') }}</a>
    </div>
  </nav>
  </div>
</template>

<script setup lang="ts">
import i18n from '@/i18n';
import { openCalendlyDemo, CALENDLY_DEMO_URL } from '@/utils/calendly';
import logoQueryLexroom from '@/assets/hero-v2/logo-query-lexroom-nav.svg';
const t = (key) => i18n.t(key);
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* Navbar du site : maquette Figma « navbar » (charte Lexroom) */
.blognav-root { display: contents; }

.lexroom-banner {
  display: block;
  background: #0f4c9d;
  color: #fff;
  text-decoration: none;
  transition: background-color .2s ease;
}
.lexroom-banner:hover { background: #0c3f84; color: #fff; }
.lexroom-banner:focus-visible {
  outline: 3px solid #80b6fd;
  outline-offset: -3px;
}
.lexroom-banner-inner {
  margin: 0 auto;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  line-height: normal;
  -webkit-font-smoothing: antialiased;
}
.lexroom-banner-brand { font-size: 14px; font-weight: 700; }
.lexroom-banner-arrow { flex-shrink: 0; transition: transform .2s ease; }
.lexroom-banner:hover .lexroom-banner-arrow { transform: translateX(3px); }

.my-nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 120px;
  background: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  color: #1a1a1c;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
}
.my-nav-brand {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}
.my-nav-logo { display: block; width: 67px; height: 40px; }
.my-nav-links {
  display: flex;
  gap: 32px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.my-nav-link {
  display: inline-block;
  position: relative;
  padding: 4px 0;
  font-weight: 500;
  font-size: 15px;
  line-height: normal;
  color: #1a1a1c;
  text-decoration: none;
  white-space: nowrap;
  transition: color .2s ease;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.my-nav-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0;
  background-color: #1c73e7;
  transition: width 0.3s ease;
}
.my-nav-link:hover { color: #1c73e7; }
.my-nav-link:hover::after,
.my-nav-link.active::after { width: 100%; }
.my-nav-link.active { color: #1c73e7; }
.my-nav-link:focus-visible {
  outline: 2px solid #1c73e7;
  outline-offset: 2px;
}

.my-nav-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.signin-link,
.cta-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 22px;
  border-radius: 99px;
  font-weight: 600;
  font-size: 14px;
  line-height: normal;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color .2s ease, transform .2s ease;
}
.signin-link { color: #1a1a1c; }
.signin-link:hover { background: rgba(15, 76, 157, 0.06); color: #1a1a1c; }
.cta-btn { background: #1c73e7; color: #fff; }
.cta-btn:hover { background: #1562c9; color: #fff; transform: translateY(-1px); }

@media (max-width: 1100px) {
  .my-nav { padding: 14px 40px; }
  .my-nav-links { gap: 20px; }
}

/* Mobile : pas de menu burger, on garde le logo et les actions pour ne
   plus deborder de l'ecran */
@media (max-width: 860px) {
  .my-nav { padding: 12px 20px; }
  .my-nav-links { display: none; }
}
@media (max-width: 420px) {
  .signin-link { padding: 10px 12px; }
  .cta-btn { padding: 10px 16px; }
}
</style>
